import * as React from 'react';
import { Link } from 'react-router-dom';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { getAjaxhelper } from '../utils/CoreAjaxHelper';
import { isNull } from '../utils/index';
export interface SitemapProps extends BaseComponentProps {
    lang: string;
    history?: History;
}

export interface SitemapState extends BaseComponentState {
    requesting: boolean;
    data: any;
    cssClass: any;
    readMore: any;
}

export class Sitemap extends BaseComponent<SitemapProps, SitemapState> {

    constructor(props: SitemapProps) {
        super(props);
        this.state = {
            requesting: true,
            data: null,
            cssClass: {},
            readMore: {}
        };
    }

    componentDidMount() {
        this.getData();
    }
    getData: () => any = () => {
        getAjaxhelper().get("/dynamics/hb-api/cms-slug").then(d => {
            this.setStateHelper(st => {
                st.requesting = false;
                st.data = d;
                for (let a of Object.keys(d)) {
                    if (isNull(st.readMore[a])) {
                        st.readMore[a] = 'Read More';
                    }
                    if (isNull(st.cssClass[a])) {
                        st.cssClass[a] = 'short-500';
                    }
                }
            });
        }).catch(exc => {
            console.log(exc);
        });
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        let page: any[] = [];
        if (this.state.requesting === false) {
            for (let a of Object.keys(this.state.data)) {
                let liList: any[] = [];
                for (let b of this.state.data[a]) {
                    liList.push(
                        <li>
                            <Link to={`/${b.slug}`}>{b.title}</Link>
                        </li>
                    );
                }
                let Header = '';
                if (a === 'Hotel') {
                    Header = 'List Of Hotels';
                } else if (a === 'Master') {
                    Header = 'Main Menu';
                } else if (a === 'CmsDestinationsZones') {
                    Header = 'Bali Destination';
                } else if (a === 'CmsHotelSegment') {
                    Header = 'Type of Hotels';
                } else if (a === 'CmsPromotion') {
                    Header = 'Hotel Promotions';
                } else if (a === 'CmsBlog') {
                    Header = 'About Bali ';
                }

                page.push(
                    <div style={{ marginBottom: 30 }}>
                        <h3>{Header}</h3>
                        <ul className={this.state.cssClass[a]}>
                            {liList}
                        </ul>
                        <button
                            className='btn btn-0'
                            onClick={() => {
                                this.setStateHelper(
                                    (st) => {
                                        if (st.cssClass[a] === 'short-500') {
                                            st.cssClass[a] = 'long-auto';
                                            st.readMore[a] = 'Read Less';
                                        } else {
                                            st.cssClass[a] = 'short-500';
                                            st.readMore[a] = 'Read More';
                                        }
                                    });
                            }}
                        >{this.state.readMore[a]}
                        </button>
                    </div>
                );
            }
        } else {
            page.push(<span />);
        }
        return (
            <div>
                {page}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/static-content/Sitemap.tsx